import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { NbRoleProvider } from '@nebular/security';
import { AuthService } from './auth.service';
import { UserService } from '../services/user/user.service';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { User } from '../services/user/user';


@Injectable()
export class RolesProvider implements NbRoleProvider {

    role: string;
    constructor(private user: UserService, private authService: AuthService) {
    }

    getRole(): Observable<string> {
        // If role already cached, return it
        if (this.role) return of(this.role);
        
        // If authService already has the role from login, use it
        if (this.authService.userRole) {
            this.role = this.authService.userRole;
            return of(this.role);
        }
        
        // Fallback: fetch from gateway API using JWT token
        return this.authService.getUserToken$().pipe(
            switchMap(token => this.user.getUserDataFromGateway(this.authService.refactoredId)),
            tap(userData => {
                if (userData) {
                    this.role = userData.role;
                }
            }),
            switchMap((userData) => userData ? of(this.role) : of('guest')),
            catchError((err) => of('guest'))
        );
    }
}
